<template>
  <div>
    <div class="steps" id="stepsDemo">
      <div v-bind:class="['step-item', dndxFlowStep === 1 ? 'is-active' : '']">
        <div class="step-marker">1</div>
        <div class="step-details">
          <p class="step-title">Client Values</p>
        </div>
      </div>
      <div v-bind:class="['step-item', dndxFlowStep === 2 ? 'is-active' : '']">
        <div class="step-marker">2</div>
        <div class="step-details">
          <p class="step-title">Risk Preferences</p>
        </div>
      </div>
      <div v-bind:class="['step-item', dndxFlowStep === 3 ? 'is-active' : '']">
        <div class="step-marker">3</div>
        <div class="step-details">
          <p class="step-title">Finalize</p>
        </div>
      </div>
    </div>

    <div v-if="dndxFlowStep === 1" class="has-text-centered">
      <p>Complete or send the Values Questionnaire</p><br>
      <a class="button is-success" v-bind:href="questionnaireUrl" v-on:click="() => { this.dndxFlowStep += 1 }" target="_blank">
        Begin
      </a>
    </div>
    <div v-if="dndxFlowStep === 2">
      <form ref="accountDetailsForm" v-on:submit.prevent="submitAccountDetails">
        <div class="field">
          <div class="control has-icons-right">
            <a class="button is-primary is-light has-icons-right" v-bind:href="`https://www.hiddenlevers.com/l/survey/external?advisor=${$root.advisor.hidden_levers_email}`" target="_blank">
              Orion Risk Intelligence Questionnaire
            </a>
            <b-icon pack="fas" icon="external-link-alt"></b-icon>
          </div>
        </div>

        <div class="field">
          <label class="label">Account Size</label>
          <div class="control has-icons-right">
            <input class="input" type="text" placeholder="$5,000,000" required v-model="accountDetails.dollars">
          </div>
        </div>

        <div class="field">
          <label class="label">Select Benchmark</label>
          <div class="control">
            <div class="select">
              <select required v-model="accountDetails.universe">
                <option v-for="(itm, idx) in availableUniverseModels">{{ itm }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">Specific Companies to Exclude</label>
          <div class="control has-icons-right">
            <input class="input" type="text" placeholder="TSLA, AMZN" v-model="accountDetails.exclusions">
          </div>
        </div>

        <div class="field">
          <button class="button is-success">Continue</button>
        </div>
      </form>
    </div>
    <div v-if="dndxFlowStep === 3">
      <div class="field has-text-centered">
        <div class="buttons is-centered">
          <p><a v-bind:class="['button', 'is-success', 'is-light', isFinalSubmit ? 'disabled' : '']" v-bind:href="companyScreenerLink(portfolio)" target="_blank">Review Impact Preferences</a></p><br>
          <p v-if="error">There was an error submitting your request, please contact us at support@yourstake.org.<br></p>
          <b-tooltip label="Submit preferences for portfolio optimization to Formative"> 
            <button v-bind:class="['button', 'is-success', isFinalSubmit ? 'disabled' : '']" v-on:click="updateDndxStatus">{{ submitLanguage }}</button>
          </b-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dndxFlowStep: 1,
        benchmarkPortfolioName: null,
        error: null,

        submitLanguage: 'Submit Portfolio',
        isFinalSubmit: false,

        accountDetails: {
          dollars: null,
          universe: null,
          exclusions: null,
        },

        // TODO: These need to be coming from an API call instead of being hardcoded, however there are some design
        // considerations that add just enough overhead that I'm sitting on it for the moment as there is only one
        // set of portfolios that will be immediately used.
        availableUniverseModels: [
          'VADIS More Aggressive Benchmark (100-0)',
          'VADIS Aggressive Benchmark (88-12)',
          'VADIS Moderately Aggressive Benchmark (77-23)',
          'VADIS Moderate Benchmark (65-35)',
          'VADIS Moderately Conservative Benchmark (53-47)',
          'VADIS Conservative Benchmark (42-58)',
          'VADIS More Conservative Benchmark (30-70)',
        ],
      }
    },
    components: {},
    props: {
      portfolio: Object,
      callback: Function,
    },
    methods: {
      submitAccountDetails: function() {
        this.dndxFlowStep += 1;
      },
      updateDndxStatus: async function() {
        this.submitLanguage = 'Sending...';
        this.isFinalSubmit = true;
        let response = await fetch(
          `/api/v1/integrations/fafn/account_dndx/${this.portfolio.id}/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.$root.$data.csrfToken,
          },
          body: JSON.stringify({
            fafn_dndx: {
              enabled: true,
              ...this.accountDetails,
            }
          })
        });
        let data = await response.json();
        if (data.errors) {
          this.submitLanguage = 'Submit Portfolio';
          this.isFinalSubmit = false;
          this.error = true;
        }
        else {
          this.portfolio.metadata = data.account.metadata;
          this.callback.call();
        }
      },
      companyScreenerLink: function(account) {
        let params = {
          values_from: this.portfolio.id,
          account: account.id,
        }
        let nonPersonaScreenSets = this.portfolio.screen_sets.filter((itm) => { return itm.is_template === false && !itm.internal_identifier});
        if (nonPersonaScreenSets.length > 0) {
          params.screen_set = nonPersonaScreenSets[0].id;
        }
        if (this.accountDetails.universe) {
          // I realize this is super hacky, but soon we will do something totally different where people just select low/medium/high preference so it will be a totally different
          params.universe_portfolio_name = "VADIS Default Universe";
        }
        return `/advisordashboard/portfolio-builder/?${new URLSearchParams(params)}`;
      }

    },
    computed: {
      questionnaireUrl: function() {
        return `${window.location.protocol}//${window.location.host}/questionnaire/questions/v2_${btoa(this.portfolio.id)}/`;
      },
      displayRows: function() {
        if (this.portfolio.accounts) {
          return this.portfolio.accounts;
        }
        else {
          return [this.portfolio]; // galaxy brain duck typing
        }
      }
    },
    created: function() {
    },
    mounted: async function() {
    }
  }
</script>

<style lang="scss" scoped>
</style>
